// extracted by mini-css-extract-plugin
export default {"slider":"slider--qWEEG","range":"range--SkBIn","icon":"icon--fWBCK"};